import { render } from "./MediaDetails.vue?vue&type=template&id=275382c3&scoped=true"
import script from "./MediaDetails.vue?vue&type=script&lang=js"
export * from "./MediaDetails.vue?vue&type=script&lang=js"

import "./MediaDetails.vue?vue&type=style&index=0&id=275382c3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-275382c3"]])

export default __exports__